interface FileListProps {
  files: File[];
  isUploading: boolean;
  onUpload: () => void;
}

export const FileList = ({ files, isUploading, onUpload }: FileListProps) => {
  if (files.length === 0) return null;

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium">Selected Files</h3>
      <div className="space-y-2">
        {files.map((file, index) => (
          <div
            key={index}
            className="text-sm p-2 bg-secondary rounded flex justify-between items-center"
          >
            <span className="truncate">{file.name}</span>
            <span className="text-xs text-muted-foreground">
              {(file.size / 1024 / 1024).toFixed(2)} MB
            </span>
          </div>
        ))}
      </div>
      <button
        onClick={onUpload}
        disabled={isUploading}
        className="w-full bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-all duration-200 disabled:opacity-50"
      >
        {isUploading ? "Uploading..." : "Upload Files"}
      </button>
    </div>
  );
};